// Arc Testnet Chain Definition
export const arcTestnet = {
  id: 5042002,
  name: "Arc Testnet",
  network: "arc-testnet",
  nativeCurrency: {
    decimals: 18,
    name: "USDC",
    symbol: "USDC",
  },
  rpcUrls: {
    default: { http: ["https://rpc.testnet.arc.network"] },
    public: { http: ["https://rpc.testnet.arc.network"] },
  },
  blockExplorers: {
    default: { name: "Arc Explorer", url: "https://testnet.arcscan.app" },
  },
  testnet: true,
};

// Unichain Sepolia Chain Definition
export const unichainSepolia = {
  id: 1301,
  name: "Unichain Sepolia",
  network: "unichain-sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: { http: ["https://sepolia.unichain.org"] },
    public: { http: ["https://sepolia.unichain.org"] },
  },
  blockExplorers: {
    default: { name: "Uniscan", url: "https://unichain-sepolia.blockscout.com" },
  },
  testnet: true,
};

// World Chain Sepolia Chain Definition
export const worldchainSepolia = {
  id: 4801,
  name: "World Chain Sepolia",
  network: "worldchain-sepolia",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH",
  },
  rpcUrls: {
    default: { http: ["https://worldchain-sepolia.drpc.org"] },
    public: { http: ["https://worldchain-sepolia.g.alchemy.com/public"] },
  },
  blockExplorers: {
    default: { name: "Worldscan", url: "https://sepolia.worldscan.org" },
  },
  testnet: true,
};

// Contract addresses and domains
export const CONTRACTS = {
  ARC_TESTNET_USDC: "0x3600000000000000000000000000000000000000",
  BASE_SEPOLIA_USDC: "0x036CbD53842c5426634e7929541eC2318f3dCF7e",
  ETH_SEPOLIA_USDC: "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238",
  UNICHAIN_SEPOLIA_USDC: "0x31d0220469e10c4E71834a79b1f276d740d3768F",
  WORLDCHAIN_SEPOLIA_USDC: "0x66145f38cBAC35Ca6F1Dfb4914dF98F1614aeA88",
};

export const DOMAINS = {
  ARC_TESTNET: 7,
  BASE_SEPOLIA: 6,
  ETH_SEPOLIA: 0,
  UNICHAIN_SEPOLIA: 10,
  WORLDCHAIN_SEPOLIA: 14,
};

// Supported chains list (for dropdowns)
export const SUPPORTED_CHAINS = [
  { id: arcTestnet.id, name: "Arc Testnet" },
  { id: 84532, name: "Base Sepolia" },
  { id: 11155111, name: "ETH Sepolia" },
  { id: 1301, name: "Unichain Sepolia" },
  { id: 4801, name: "World Chain Sepolia" },
];

// BridgeKit chain name mapping
export const BRIDGEKIT_CHAIN_NAMES = {
  [arcTestnet.id]: "Arc_Testnet",
  84532: "Base_Sepolia",
  11155111: "Ethereum_Sepolia",
  1301: "Unichain_Sepolia",
  4801: "World_Chain_Sepolia",
};

// USDC contract address by chain ID
export const USDC_BY_CHAIN = {
  [arcTestnet.id]: CONTRACTS.ARC_TESTNET_USDC,
  84532: CONTRACTS.BASE_SEPOLIA_USDC,
  11155111: CONTRACTS.ETH_SEPOLIA_USDC,
  1301: CONTRACTS.UNICHAIN_SEPOLIA_USDC,
  4801: CONTRACTS.WORLDCHAIN_SEPOLIA_USDC,
};

// Default transfer values
export const DEFAULTS = {
  AMOUNT: "1",
  MAX_FEE: "0.0005",
  MAX_ALLOWANCE: "10000",
  MIN_FINALITY_THRESHOLD: 1000,
};

// API endpoints
export const API = {
  ATTESTATION_BASE_URL: "https://iris-api-sandbox.circle.com/v2/messages",
  UNISWAP_API_URL: "https://trade-api.gateway.uniswap.org/v1",
};

// Wrapped native token addresses by chain ID (for swaps)
export const WETH_BY_CHAIN = {
  11155111: "0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14", // WETH on ETH Sepolia
  84532: "0x4200000000000000000000000000000000000006",   // WETH on Base Sepolia
  1301: "0x4200000000000000000000000000000000000006",     // WETH on Unichain Sepolia
  4801: "0x4200000000000000000000000000000000000006",     // WETH on World Chain Sepolia
};

// Chains that support Uniswap swap (ones with WETH + USDC)
export const SWAP_SUPPORTED_CHAINS = [
  { id: 11155111, name: "ETH Sepolia" },
  { id: 84532, name: "Base Sepolia" },
  { id: 1301, name: "Unichain Sepolia" },
];

// Trading API supported chain IDs (ETH Sepolia + Unichain Sepolia)
// Base Sepolia uses V4 Universal Router directly (not in API)
export const API_SWAP_CHAIN_IDS = new Set([11155111, 1301]);

// Permit2 address (same across all chains)
export const PERMIT2_ADDRESS = "0x000000000022D473030F116dDEE9F6B43aC78BA3";

// Uniswap V4 Universal Router addresses by chain
export const UNIVERSAL_ROUTER_BY_CHAIN = {
  84532: "0x492e6456d9528771018deb9e87ef7750ef184104",   // Base Sepolia
  11155111: "0x3A9D48AB9751398BbFa63ad67599Bb04e4BdF98b", // ETH Sepolia
  1301: "0xf70536b3bcc1bd1a972dc186a2cf84cc6da6be5d",    // Unichain Sepolia
};

// Uniswap V4 Quoter addresses by chain
export const V4_QUOTER_BY_CHAIN = {
  84532: "0x4a6513c898fe1b2d0e78d3b0e0a4a151589b1cba",   // Base Sepolia
  11155111: "0x61b3f2011a92d183c7dbadbda940a7555ccf9227", // ETH Sepolia
  1301: "0x56dcd40a3f2d466f48e7f48bdbe5cc9b92ae4472",    // Unichain Sepolia
};

// Transfer steps
export const STEPS = [
  "Connect Wallet",
  "Enter Amount",
  "Bridge Transfer",
  "Complete",
];
